import { IconClose } from "../../../../components/Icon/Icon";
import Modal from "../../../../components/Modal/Modal";
import "./PublicModal.scss";
type Props = {
  showModal: boolean;
  closeModal: (...args: Array<any>) => any;
  content: any;
};

const PublicModal = (props: Props): React.JSX.Element => {
  const { showModal, closeModal, content } = props;
  return (
    <Modal
      modalOpen={showModal}
      closeModal={closeModal}
      contentLabel="Public modal"
      cancelButton
      cancelButtonText="Close"
      className="public-modal"
    >
      <div className="publicModal__close">
        <div onClick={closeModal}>
          <IconClose />
        </div>
      </div>
      {content}
    </Modal>
  );
};

export default PublicModal;
